<template>
  <div class="home">
    <!-- header -->
    <!-- <nav-header></nav-header> -->

    <div class="bg" :style="{background: bg}">
      <div class="mask"></div>
      <el-popover
        placement="top-start"
        width="550"
        popper-class="news-pop"
        trigger="hover">
        <el-carousel class="news-swiper" trigger="click" arrow="always" :autoplay="false" :loop="false" :initial-index="index">
          <el-carousel-item v-for="(item, index) in newsList" :key="index">
            <div class="banner-text-box">
              <div class="left">
                <img :src="item.img"/>
              </div>
              <div class="right">
                <div class="banner-text">{{language == '1' ? item.title : item.titleEN}}</div>
                <p>{{language == '1' ? item.content : item.contentEN}}</p>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
        <div class="news" slot="reference">{{language == '1' ? '资讯' : 'NEWS' }}</div>
      </el-popover>
      <div :class="{text: true, active: showText}">
        <div class="title">{{language == '1' ? text.title : text.titleEN}}</div>
        <div class="content">{{language == '1' ? text.content : text.contentEN}}</div>
        <div class="btn">
          <el-button size="small" @click="$router.push('/about')">{{language == '1' ? text.btn1 : text.btn1EN}}</el-button>
          <el-button size="small" @click="$router.push('/productLine')">{{language == '1' ? text.btn2 : text.btn2EN}}</el-button>
        </div>
      </div>
      <div class="foot">
        <p>© Copyright 2021<span style="margin: 0 20px">|</span>MAFCO 沪ICP备100000-0<span style="margin: 0 20px">|</span>All Rights Reserved</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'home',
  computed: {
    language () {
      return this.$store.state.language || '1'
    }
  },
  data () {
    return {
      bg: `url("${require('../../assets/img/home-bg.jpg')}") no-repeat`,
      text: {
        title: '麦福甘草',
        titleEN: 'Mafco',
        content: '麦福环球是甘草制品界的全球引领者，距今已有170多年历史',
        contentEN: 'For over 170 years MAFCO has been the world’s leading manufacturer of natural licorice products. ',
        btn1: '关于Mafco',
        btn1EN: 'About Mafco',
        btn2: '产品目录',
        btn2EN: 'Product Line'
      },
      newsList: [/* {
        title: '2021年3月24日 - 3月26日',
        titleEN: 'March 24 - March 26,2021',
        content: '在深圳会展中心参加PCHi2021中国国际化妆品个人及家庭护理用品原料展览会',
        contentEN: 'Personal Care and Homecare Ingredients 2021 in Shenzhen, China',
        img: require('@/assets/img/news3.png')
      }, {
        title: '2021年4月14日-4月15日',
        titleEN: 'April 14 - April 15,2021',
        content: '在上海参加中国口腔清洁护理用品工业协会第八届三次理事扩大会议',
        contentEN: 'The third Session of the Eighth Council of China Oral Care Industry Association in Shanghai, China',
        img: require('@/assets/img/news2.png')
      }, {
        title: '2021年6月8日 - 6月10日',
        titleEN: 'June 8 - June 10，2021',
        content: '在上海国家会展中心参加第二十四届中国国际食品添加剂和配料展览会（FIC2021）',
        contentEN: 'Food Ingredients China-Health 2021 in Shanghai, China',
        img: require('@/assets/img/news1.png')
      }, */ {
        title: '2024年3月20日 - 3月22日',
        titleEN: 'March 20th - March 22nd，2024',
        content: '展位号：1M02 - PCHi2024中国国际化妆品个人及家庭护理用品原料展览会',
        contentEN: 'Booth No: 1M02 - China International Cosmetic Personal and Home Care Ingredients Exhibition (PCHi2024)',
        img: require('@/assets/img/news3.png')
      },{
        title: '2024年3月20日 - 3月22日',
        titleEN: 'March 20th - March 22nd, 2024',
        content: '展位号：41S09 - 第二十七届中国国际食品添加剂和配料展览会（FIC2024）',
        contentEN: 'Booth No: 41S09 - The 27th China International Food Additives and Ingredients Exhibition (FIC2024)',
        img: require('@/assets/img/news1.png')
      },{
        title: '2024年6月19日 - 6月21日',
        titleEN: 'June 19th -June 21st, 2024',
        content: '展位号：E4C49 - 第二十二届世界制药原料中国展CPHI',
        contentEN: 'Booth No: E4C49 - 22nd World Pharmaceutical Raw Materials China Exhibition (CPHI)',
        img: require('@/assets/img/cphi.png')
      },{
        title: '2024年11月',
        titleEN: 'November, 2024',
        content: '2024个人护理品技术高峰论坛（上海荣格展览有限公司',
        contentEN: '2024 Personal Care Technology Summit (Shanghai Ringier Exhibition Co., Ltd.（Shanghai Ringier Exhibition Co., Ltd）',
        img: require('@/assets/img/re.png')
      } ],
      showText: false,
      index: 0
    }
  },
  mounted () {
    this.index = 0
    this.showText = true
  }
}
</script>
<style lang="less" scoped>
html, body {
  overflow: hidden !important;
}
.news-swiper {
  height: 130px;
  /deep/ .el-carousel__container {
    max-height: 130px;
  }
  .banner-text-box {
    padding: 20px 70px;
    display: flex;
    word-break: break-word;
    .left {
      flex: 0;
      width: 80px;
      margin-right: 15px;
      img {
        width: 80px;
        border: solid 1px #006838;
      }
    }
    .right {
      flex: 1;
      .banner-text {
        font-weight: bold;
        font-size: 20px;
        line-height: 40px;
      }
    }
  }
}
.home {
  overflow: hidden;
  .bg {
    width: 100vw;
    height: 100vh;
    background-size: cover !important;
    .mask {
      width: 100vw;
      height: 100vh;
      background-color: rgba(0, 0, 0, 0.5);
    }
  }

  .news {
    width: 80px;
    height: 80px;
    line-height: 80px;
    border-radius: 50%;
    background-color: rgba(0, 104, 56, 1);
    color: #fff;
    position: fixed;
    bottom: 100px;
    left: 100px;
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
    -webkit-transition-property: background-color;
    -webkit-transition-property: font-size;
    -webkit-transition-property: font-weight;
    -webkit-transition-duration: 0.3s;
    -webkit-transition-timing-function: ease;
    &:hover {
      background-color: #006838;
      font-size: 18px;
      font-weight: bold;
    }
  }
  .text {
    position: fixed;
    top: 40%;
    left: -100%;
    color: #fff;
    transition: left .8s;
    -moz-transition: left .8s;
    -webkit-transition: left .8s;
    -o-transition: left .8s;
    &.active {
      left: 15%;
    }
    .title {
      font-size: 50px;
      line-height: 80px;
    }
    .content {
      width: 800px;
      font-size: 22px;
    }
    .btn {
      line-height: 80px;
      .el-button {
        font-size: 18px;
        -webkit-transition-property: background-color;
        -webkit-transition-duration: 0.15s;
        -webkit-transition-timing-function: ease;
        &:hover {
          background-color: rgba(0, 104, 56, 1);
          border-color: rgba(0, 104, 56, 1);
          color: #fff;
        }
      }
    }
  }
  .foot {
    position: fixed;
    left: 0;
    bottom: 10px;
    height: 20px;
    width: 100vw;
    color: rgba(255, 255, 255, 0.5);
    padding-left: 30px;
    text-align: center;
    font-size: 12px;
    p:first-of-type {
      color: rgba(255, 255, 255, .5);
    }
    p:hover {
      color: rgba(255, 255, 255, 1);
    }
  }
}
</style>
